module.exports = __webpack_public_path__ + "static/media/kuakata_beach.8b496bed.jpg";